// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"24131e22","93":"bdbea60a","259":"e9837b29","286":"a87ff972","780":"ab8b9400","816":"7808475d"}[chunkId] + ".chunk.js";
};